import 'particles.js/particles.js'
import 'jquery'
import 'bootstrap'
import './css/site_index.sass'
import { createCarousel } from '../../dovirus/static/carousel'

$(() => {
    if ($("#particles-js").length)
        (<any>window).particlesJS.load('particles-js', '/static/vendor/particles.json')
    createCarousel()
})



// WEBPACK FOOTER //
// ./btdraw/static/site_page.ts